import Constants from "../utils/consts";
import Utils from "../utils/utils";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function addTag(uname, token, tag, categoriaTag) {
	console.log(categoriaTag, typeof categoriaTag);
	return new Promise(function(resolve, reject) {
		var options = {
			method: "POST",
			hostname: Constants.ipAddress,
			path: Constants.apisFolder + "addTag.php",
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
				Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
			},
			maxRedirects: 20,
		};

		var req = http.request(options, function(res) {
			var chunks = [];

			res.on("data", function(chunk) {
				chunks.push(chunk);
			});

			res.on("end", function(chunk) {
				var body = Buffer.concat(chunks);

				try {
					let jsonResponse = JSON.parse(body);
					// Verifica se il tag già esiste
					if (
						jsonResponse.result === "KO" &&
						jsonResponse.error === "Tag already exists with the same category"
					) {
						reject("Tag già esistente");
					} else {
						resolve(jsonResponse);
					}
				} catch (error) {
					reject("Errore nel parsing della risposta JSON: " + error.message);
				}
			});

			res.on("error", function(error) {
				console.error(error);
			});
		});

		var postData = qs.stringify({
			token: token,
			uname: uname,
			tag: tag,
			categoriaTag: categoriaTag,
		});

		req.write(postData);
		req.end();
	});
}
